import {ReactElement, useCallback} from 'react';
import {EnvironmentType} from '../../../../shared/model/EnvironmentType.model';
import {TransHelper} from '../../../../utils/trans-helper';
import {NxFormikInput} from '../../../shared/nxInput/NxFormikInput';
import styles from './CustomEnvironementSettings.module.scss';
import FormikStaticInput from '../../../shared/formikStaticInput/FormikStaticInput';
import NxGenericTextField from '../../../shared/nxGenericTextField/NxGenericTextField';
import {MenuItem} from '@material-ui/core';
import {CustomEnvironmentFormFields} from './CustomEnvironmentSettings.model';
import clsx from 'clsx';
import {EnvironmentsFormFields} from '../Environment.form.model';
import {StatusPageHandling} from '../Environment.model';

const PrefixTrans = TransHelper.getPrefixedTrans('SETTINGS.ENVIRONMENT');
const SharedTrans = TransHelper.getPrefixedTrans('SHARED');

export default function CustomSettingsEnvironmentForm({
  environmentType,
  values,
  setFieldValue
}: {
  environmentType: EnvironmentType,
  values: EnvironmentsFormFields<CustomEnvironmentFormFields>;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
}): ReactElement {

  const externalStatusPageEnabled = values[environmentType]?.externalStatusPageEnabled;

  const onChangeStatusPageHandling = useCallback((value: boolean) => {
    setFieldValue(`${environmentType}.externalStatusPageEnabled`, value);
  }, []);

  return (
    <div>
      <FormikStaticInput
        label={<PrefixTrans>ACCESS_KEY</PrefixTrans>}
        name={`${environmentType}.accessKey`}
        disabled
        className={styles.staticInput} />
      <FormikStaticInput
        label={<PrefixTrans>SECRET_KEY</PrefixTrans>}
        name={`${environmentType}.secretKey`}
        disabled
        className={styles.staticInput} />
      <div className={styles.inputs}>
        <div className={styles.helperText}>
          <PrefixTrans>STATUS_PAGE_HANDLING_HELPER_TEXT</PrefixTrans>
        </div>
        <NxGenericTextField
          select
          className={styles.input}
          name={`${environmentType}.externalStatusPageEnabled`}
          value={String(externalStatusPageEnabled)}
          label={<PrefixTrans>STATUS_PAGE_HANDLING</PrefixTrans>}>
          <MenuItem
            value='false'
            onClick={() => onChangeStatusPageHandling(false)}>
            <SharedTrans>{StatusPageHandling.SWIFTPAY}</SharedTrans>
          </MenuItem>
          <MenuItem
            value='true'
            onClick={() => onChangeStatusPageHandling(true)}>
            <SharedTrans>{StatusPageHandling.EXTERNAL}</SharedTrans>
          </MenuItem>
        </NxGenericTextField>
        {!externalStatusPageEnabled
          ? <>
            <div className={styles.helperText}>
              <PrefixTrans>SUCCESS_URL_HELPER_TEXT</PrefixTrans>
            </div>
            <NxFormikInput
              className={styles.input}
              name={`${environmentType}.successUrl`}
              label={<PrefixTrans>SUCCESS_URL</PrefixTrans>} />
            <div className={styles.helperText}>
              <PrefixTrans>CANCEL_URL_HELPER_TEXT</PrefixTrans>
            </div>
            <NxFormikInput
              className={styles.input}
              name={`${environmentType}.cancelUrl`}
              label={<PrefixTrans>CANCEL_URL</PrefixTrans>} />
            <div className={styles.helperText}>
              <PrefixTrans>FAILURE_URL_HELPER_TEXT</PrefixTrans>
            </div>
            <NxFormikInput
              className={styles.input}
              name={`${environmentType}.failureUrl`}
              label={<PrefixTrans>FAILURE_URL</PrefixTrans>} />
          </>
          : <>
            <NxFormikInput
              className={clsx(styles.input, styles.externalUrlInput)}
              name={`${environmentType}.externalStatusPageUrl`}
              label={<PrefixTrans>EXTERNAL_STATUS_PAGE_URL</PrefixTrans>} />
          </>
        }
        <div className={styles.helperText}>
          <PrefixTrans>CALLBACK_URL_HELPER_TEXT</PrefixTrans>
        </div>
        <NxFormikInput
          className={styles.input}
          name={`${environmentType}.callbackUrl`}
          label={<PrefixTrans>CALLBACK_URL</PrefixTrans>} />
      </div>
    </div>
  );
}
